"use strict";

require("./404");
require("./achievement");
require("./admin");
require("./agent");
require("./almond");
require("./auction");
require("./back-top");
require("./bag");
require("./banner");
require("./battery");
require("./bug");
require("./building");
require("./chart");
require("./clipboard");
require("./component");
require("./coupon");
require("./dashboard");
require("./delivery-truck");
require("./documentation");
require("./drag");
require("./driver");
require("./edit");
require("./education");
require("./email");
require("./example");
require("./excel");
require("./exit-fullscreen");
require("./eye-off");
require("./eye-on");
require("./faq");
require("./form");
require("./fullscreen");
require("./globe");
require("./guide-2");
require("./guide");
require("./hamburger");
require("./icon");
require("./inr");
require("./international");
require("./language");
require("./like");
require("./link");
require("./list");
require("./location");
require("./lock");
require("./marketing");
require("./message");
require("./money");
require("./nested");
require("./orderCancel");
require("./orderDelivered");
require("./orderPlaced");
require("./outForDelivery");
require("./password");
require("./pdf");
require("./people");
require("./peoples");
require("./prize");
require("./product");
require("./qq");
require("./riyal");
require("./sack");
require("./scale");
require("./search");
require("./setting");
require("./shopping");
require("./size");
require("./skill");
require("./star");
require("./tab");
require("./table");
require("./tag");
require("./tax");
require("./theme");
require("./tree-table");
require("./tree");
require("./user");
require("./vehicle");
require("./wechat");
require("./zip");